import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            韩漫分类浏览
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            八大韩漫分类，总有一款适合你。点击探索你感兴趣的韩漫类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category?tab=${cat.slug}`}
              className="group relative bg-background-100 rounded-xl p-5 md:p-6 hover:bg-primary-50 transition-all duration-300 cursor-pointer border border-transparent hover:border-primary-200"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部分类
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}